import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentTenderFailuresPage() {
  return <LatamAgentPage locale="pt-BR" agentKey="tender_failures" />;
}
